import { isSameDay } from 'date-fns';

import { parseDateToUtc } from '@app/utils';

import { BadgeStatus, BillingAccount, BillingStatus, Locale, ProductInstanceStatus } from '@mfe/shared/schema-types';

export const getBillingContext = (
  productInstanceStatus?: string | null,
  billingAccount?: BillingAccount | null,
  locale?: Locale | null,
  summaryInvoiceStatus?: BadgeStatus | null
) => {
  const balance = billingAccount?.balance?.value ?? 0;

  const variables = {
    context: billingAccount?.billingStatus,
    billDate: parseDateToUtc(billingAccount?.billDate ?? undefined),
    dueDate: parseDateToUtc(billingAccount?.dueDate ?? undefined),
    payDate: parseDateToUtc(billingAccount?.payDate ?? undefined),
  };

  // new
  if (billingAccount?.billingStatus === BillingStatus.New) {
    if (productInstanceStatus === ProductInstanceStatus.Active) return { ...variables, context: 'NewFirstBillDate' };
    if (locale === Locale.PtBr && balance >= 0) return { ...variables, context: 'NewPaymentDueToday' };
    if (locale === Locale.ItIt && balance >= 0) return { ...variables, context: 'NewFirstBillNextCycle' };
  }

  // ready (autopay)
  if (billingAccount?.billingStatus === BillingStatus.Ready && billingAccount?.payDate) {
    return { ...variables, context: 'BillReadyAutopay' };
  }

  if (!billingAccount?.dueDate) return variables;

  // ready (not today)
  const today = new Date();
  const dueDate = parseDateToUtc(billingAccount.dueDate);
  if (billingAccount?.billingStatus === BillingStatus.Ready && !isSameDay(today, dueDate)) {
    return { ...variables, context: 'BillReadyPaymentDue' };
  }

  if (locale === Locale.PtBr && summaryInvoiceStatus === BadgeStatus.PastDue)
    return { ...variables, context: 'LateInvoice' };

  // current / ready (today) / past
  return variables;
};
